


























































































































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import {Title, ValueView} from '@/components';
import {SpecialOfferTile} from '@/components/SpecialOfferTile';
import {ProfileApartmentOneCreate} from '@/components/ProfileApartmentOneCreate';
import {AddingLodgers} from '@/components/AddingLodgers';
import {ChangeTerms} from '@/components/ChangeTerms';
import {mapGetters, mapActions} from 'vuex';
import { formMixins } from '@/components/SignUpForm/mixins';

@Component({
  name: 'ProfileApartmentOneAbout',
  components: {
    ProfileApartmentOneCreate,
    SpecialOfferTile, Title, ValueView, AddingLodgers, ChangeTerms,
  },
  props: {
    apartment: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showPopup: false,
      routeLink: null,
      ready: false,
      showAddingLodgersModal: false,
      addingLodgersHasError: false,
      lodgerEmail: '',
      lodgerThank: false,
      lodgersPage: false,
      changeTerms: false,
      errorMessage: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.stepNumber !== 0) {
      this.showPopup = true;
      this.routeLink = to;
      if (this.ready) {
        this.ready = false;
        next();
      }
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters('profile', ['myApartmentsTexts', 'myApartments', 'stepNumber', 'lodgersBlockTexts']),
    ...mapGetters('user', ['loggedUser']),
    ...mapGetters(['promo']),
    actualTitle() {
      if (this.actualApartment) {
        return `${this.myApartmentsTexts.apartment} ${this.actualApartment.number}`;
      }
    },
    actualApartment() {
      if (this.myApartments.length > 0) {
        for (const apartment of this.myApartments) {
          if ((apartment as {id}).id === parseInt(this.$route.params.id, 10)) {
            return apartment;
          }
        }
      }
    },
    error: {
      get() {
        return (this as any).errorMessage || (this as any).lodgersBlockTexts.modalAdd.error;
      },
      set(value) {
        (this as any).errorMessage = value;
      },
    },
  },
  methods: {
    ...mapActions('profile', ['addStepNumber', 'clearStepNumber', 'sendLodger']),
    ...mapActions(['showCentralAlert']),
    closeLeavePopup() {
      this.showPopup = false;
      this.routeLink = null;
    },
    sendLodgerEmail() {
      if ((this as any).emailValid((this as any).lodgerEmail)) {
        (this as any).sendLodger({id: this.actualApartment.id, email: (this as any).lodgerEmail})
            .then((resp) => {
              if (resp.status === 200) {
                (this as any).lodgerThank = true;
              } else {
                (this as any).error = resp.data.mobile_errors[0].messages[0];
                (this as any).addingLodgersHasError = true;
              }
            })
            .catch((error) => {
              console.error(error);
            });
      }
    },
    emailValid(email) {
      const err = formMixins.rules.email(
        email,
        {
          at: (this as any).lodgersBlockTexts.modalAdd.error,
          user: (this as any).lodgersBlockTexts.modalAdd.error,
          domain: (this as any).lodgersBlockTexts.modalAdd.error,
        },
      );
      (this as any).addingLodgersHasError = typeof err === 'string';
      return !(this as any).addingLodgersHasError;
    },
    closeAddingLodgersModal() {
      (this as any).showAddingLodgersModal = false;
      (this as any).addingLodgersHasError = false;
      (this as any).lodgerEmail = '';
      (this as any).lodgerThank = false;
    },
    stringWithName(str) {
      return str.replace('%(email)s', (this as any).lodgerEmail);
    },
  },
})
export default class ProfileApartmentOneAbout extends Vue {}
